module.exports = __webpack_public_path__ + "img/hardyPosture1.dd9acecc.png";